import React from 'react';

import EmptyBoxIcon from '@/assets/icons/empty-box.svg?react';

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
}

const EmptyState = ({
  title,
  subtitle,
  icon = <EmptyBoxIcon className="h-10 w-10 text-gray-600" />,
}: EmptyStateProps) => {
  return (
    <div className="flex w-full justify-center py-4" data-testid="empty-state">
      <div className="relative w-full rounded-lg border border-dashed border-gray-200 px-6 py-12 text-center">
        {/* Background decorative element */}
        <div className="absolute inset-0 rounded-lg bg-gray-50"></div>

        {/* Content */}
        <div className="relative flex flex-col items-center gap-4">
          <div className="rounded-full border bg-gray-100 p-2">{icon}</div>

          {/* Text content */}
          <div className="flex flex-col items-center gap-2">
            <h3 className="text-lg font-medium text-gray-700">{title}</h3>
            {subtitle && <div className="max-w-md text-sm leading-relaxed text-balance text-gray-400">{subtitle}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
